import useFetchPaymentMethods from '../useFetchPaymentMethods';
import useFetchPhoneTypes from '../useFetchPhoneTypes';
import useFetchRecordTypes from '../useFetchRecordTypes';
import useFetchServeMethods from '../useFetchServeMethods';
import useFetchCustodianTypes from '../useFetchCustodianTypes';
import useFetchStates from '../useFetchStates';
import useFetchTimeZones from '../useFetchTimeZones';
import useFetchOrderTypes from '../useFetchOrderTypes';
import useFetchDays from '../useFetchDays';
import useFetchDepartmentFileTypes from '../useFetchDepartmentFileTypes';
import useFetchProviders from '../useFetchProviders';
import useFetchPortalTypes from '../useFetchPortalTypes';
import useFetchFollowUpMethods from '../useFetchFollowUpMethods';
import useFetchSourceTypes from '../useFetchSourceTypes';

export default function useAddCustodianLookups() {
  const { custodianTypes } = useFetchCustodianTypes();
  const { states } = useFetchStates();
  const { phoneTypes } = useFetchPhoneTypes();
  const { portalTypes } = useFetchPortalTypes();
  const { sourceTypes } = useFetchSourceTypes();
  const { paymentMethods } = useFetchPaymentMethods();
  const { timeZones } = useFetchTimeZones();
  const { departmentFileTypes } = useFetchDepartmentFileTypes();

  const { orderTypes } = useFetchOrderTypes();
  const { followUpMethods } = useFetchFollowUpMethods();
  const { recordTypes } = useFetchRecordTypes();
  const { serveMethods } = useFetchServeMethods();
  const { days } = useFetchDays();
  const { providers } = useFetchProviders();

  return {
    recordTypes,
    serveMethods,
    phoneTypes,
    portalTypes,
    sourceTypes,
    supportedOrderTypes: orderTypes,
    states,
    custodianTypes,
    paymentMethods,
    timeZones,
    days,
    departmentFileTypes,
    providers,
    followUpMethods
  };
}
